import React from 'react';
import { SPORTS } from '../services/newsService';

/**
 * Sport selector component
 * Allows admin to choose which sport's content to view
 */
function SportSelector({ selectedSport, onSelectSport, disabled }) {
  const sports = Object.values(SPORTS);

  return (
    <div className="card card-custom p-4 mb-4">
      <h5 className="text-white mb-3">Select Sport</h5>
      <div className="d-flex flex-wrap gap-2">
        {sports.map((sport) => (
          <button
            key={sport.code}
            onClick={() => onSelectSport(sport)}
            disabled={disabled}
            className={`btn ${
              selectedSport?.code === sport.code
                ? 'btn-primary-custom'
                : 'btn-secondary-custom'
            }`}
            style={{ minWidth: '120px' }}
          >
            {sport.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SportSelector;
